import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faTimes,
  faPercent,
  faCode,
  faRotateRight,
  faCopy
} from '@fortawesome/free-solid-svg-icons';
import baseURL from '../../url';

export default function NewCodigo({ onCreated }) {
  const [isOpen, setIsOpen] = useState(false);
  const [codigo, setCodigo] = useState('');
  const [descuento, setDescuento] = useState('');
  const [loading, setLoading] = useState(false);

  // Toasts con tu sistema global
  const [toasts, setToasts] = useState([]);
  const showToast = (message, type = 'info') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3800);
  };

  const generarCodigoAleatorio = (len = 6) => {
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let out = '';
    for (let i = 0; i < len; i++) {
      out += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
    }
    return out;
  };

  const openModal = () => {
    setCodigo(generarCodigoAleatorio());
    setDescuento('');
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const copiarCodigo = async () => {
    try {
      await navigator.clipboard.writeText(codigo);
      showToast('Código copiado al portapapeles', 'success');
    } catch {
      showToast('No se pudo copiar el código', 'error');
    }
  };

  const crear = async () => {
    if (!codigo?.trim()) {
      showToast('Genera un código válido', 'warning');
      return;
    }

    const valor = Number(descuento);
    if (Number.isNaN(valor) || valor < 0) {
      showToast('El descuento debe ser un número ≥ 0', 'warning');
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('codigo', codigo);
      formData.append('descuento', String(valor));

      const response = await fetch(`${baseURL}/codigosPost.php`, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json(); // fallará si el servidor devuelve HTML
      if (data?.mensaje) {
        showToast('Código creado correctamente', 'success');
        if (typeof onCreated === 'function') onCreated();
        closeModal();
      } else {
        showToast(data?.error || 'No se pudo crear el código', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showToast('Error de conexión. Inténtalo de nuevo.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Toasts globales */}
      {toasts.length > 0 && (
        <div className="product-toast-container">
          {toasts.map(t => (
            <div key={t.id} className={`product-toast ${t.type}`}>
              <div className="toast-icon">
                {t.type === 'success' && '✅'}
                {t.type === 'error' && '❌'}
                {t.type === 'warning' && '⚠️'}
                {t.type === 'info' && 'ℹ️'}
              </div>
              <div className="toast-content">
                <div className="toast-title">{t.message}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Botón para abrir modal */}
      <button onClick={openModal} className="btn-product-primary flex-center">
        <FontAwesomeIcon icon={faPlus} />
        Agregar código
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="product-modal-backdrop">
          <div className="product-modal-container" style={{ maxWidth: 700 }}>
            {/* Header */}
            <div className="product-modal-header">
              <div className="product-modal-title">
                <FontAwesomeIcon icon={faPercent} />
                Nuevo código de descuento
              </div>
              <button className="product-close-button" onClick={closeModal}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            {/* Body */}
            <div className="product-modal-body">
              <div className="product-section-card mb-24">
                <div className="product-section-header">
                  <div className="product-section-title flex-center">
                    <FontAwesomeIcon icon={faCode} />
                    Datos del código
                  </div>
                </div>

                <div className="product-section-content">
                  <div
                    className="grid"
                    style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 16 }}
                  >
                    {/* Código (solo lectura, con regenerar y copiar) */}
                    <div className="product-form-group" style={{ gridColumn: '1 / span 2' }}>
                      <label className="product-form-label">Código</label>
                      <div className="flex-center">
                        <input
                          type="text"
                          className="product-form-input"
                          value={codigo}
                          readOnly
                          style={{ flex: 1 }}
                        />
                        <button
                          type="button"
                          className="btn-product-secondary"
                          onClick={() => setCodigo(generarCodigoAleatorio())}
                          title="Regenerar código"
                          style={{ padding: '10px 12px' }}
                        >
                          <FontAwesomeIcon icon={faRotateRight} />
                        </button>
                        <button
                          type="button"
                          className="btn-product-secondary"
                          onClick={copiarCodigo}
                          title="Copiar código"
                          style={{ padding: '10px 12px' }}
                        >
                          <FontAwesomeIcon icon={faCopy} />
                        </button>
                      </div>
                    </div>

                    {/* Descuento */}
                    <div className="product-form-group">
                      <label className="product-form-label">Descuento</label>
                      <input
                        type="number"
                        className="product-form-input"
                        value={descuento}
                        onChange={(e) => setDescuento(e.target.value)}
                        placeholder="0"
                        min="0"
                        step="1"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer acciones */}
            <div className="product-submit-section">
              <button className="btn-product-secondary" onClick={closeModal} disabled={loading}>
                Cancelar
              </button>
              <button
                className="btn-product-primary"
                onClick={crear}
                disabled={loading || !codigo?.trim()}
              >
                {loading ? 'Procesando…' : 'Agregar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
